export const getIDFromURI = (uri) => {
    const parts = uri.split('/');
    return Number(parts[parts.length - 1]) || null;
};